import MomentUtils from '@date-io/moment';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import InfoIcon from '@mui/icons-material/Info';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CITYGUIDE_INFO_TYPES,
  CITY_GUIDE_ADD_ACTIVITY_TAB,
  CITY_GUIDE_IMAGE_TYPE,
  UNITS,
  VALID_DATE_TIME_ERROR_MESSAGE,
  VALID_TIME_ERROR_MESSAGE,
} from '../../../../../constants/CityGuideConst';
import { Countries } from '../../../../../constants/Countries';
import ContactInformation from '../../../../../shared/contact-information/ContactInformation';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import LocationInput from '../../../../../shared/google-location-input/LocationInput';
import LocationMap from '../../../../../shared/google-map/LocationMap';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { addCityGuide, editCityGuide } from '../../../../../utils/cmsUtils';
import {
  formDataValidate,
  handleValidation,
  validateAlphanumeric,
} from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { allCityGuideCategoriesSelector, fetchAllCityGuide } from '../../../cmsSlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { ASSET_URL } from '../../../../../env/Configurations';
import { getPreSignedUrl } from '../../../../../utils/PropertyAPIUtils';
import { ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import { convertFileToBase64 } from '../../../../../utils/commonUtils';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const CityGuideCreate = (props) => {
  const { toggleDrawer, hotelId, cityGuide, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isValidDate, setIsValidDate] = useState(false);
  const [contactInfoList, setContactInfoList] = useState([]);
  const cityGuideCategories = useSelector(allCityGuideCategoriesSelector);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const groupId = originalHotels?.find((h) => h?.id === hotelId)?.groupId;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    categoryId: {
      value: '',
      fieldName: 'Category',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Activity Name',
      errors: {},
      validations: ['required', 'validTextWithoutGreatherOrLessthen'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    distanceFromHotel: {
      value: '',
      fieldName: 'Distance from Hotel',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    units: {
      value: '',
      fieldName: 'Units',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    duration: {
      value: 'alwaysActive',
      fieldName: 'Duration',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    validFromDate: {
      value: '',
      fieldName: 'Date',
      errors: {},
      validations: [],
      tab: 1,
    },
    validFromTime: {
      value: '',
      fieldName: 'Time',
      errors: {},
      validations: [],
      tab: 1,
    },
    tillFromDate: {
      value: '',
      fieldName: 'Date',
      errors: {},
      validations: [],
      tab: 1,
    },
    tillFromTime: {
      value: '',
      fieldName: 'Time',
      errors: {},
      validations: [],
      tab: 1,
    },
    addressLine1: {
      value: '',
      fieldName: 'Address Line 1',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    addressLine2: {
      value: '',
      fieldName: 'Address Line 2',
      errors: {},
      validations: [],
      tab: 2,
    },
    country: {
      value: '',
      fieldName: 'Country',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    state: {
      value: '',
      fieldName: 'State',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    postalCode: {
      value: '',
      fieldName: 'Postal Code',
      errors: {},
      validations: [],
      tab: 2,
    },
    city: {
      value: '',
      fieldName: 'City',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    latitude: {
      value: '',
      fieldName: 'Latitude',
      errors: {},
      validations: [],
      tab: 2,
    },
    longitude: {
      value: '',
      fieldName: 'Longitude',
      errors: {},
      validations: [],
      tab: 2,
    },
    area: {
      value: '',
      fieldName: 'Area (Ex: Downtown Avenue)',
      errors: {},
      validations: [],
      tab: 2,
    },
    timeZone: {
      value: '',
      fieldName: 'Time Zone',
      errors: {},
      validations: ['required'],
      tab: 2,
    },

    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 4,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const setInfoValue = (info) => {
    if (info.email) return info.email;
    if (info.phone) return info.phone;
    if (info.URL) return info.URL;
  };

  useEffect(() => {
    if (cityGuide) {
      const currFields = { ...formData };
      currFields.categoryId.value = cityGuide.categoryId;
      currFields.name.value = cityGuide.name;
      currFields.code.value = cityGuide.code;
      currFields.description.value = cityGuide.description;
      currFields.distanceFromHotel.value = cityGuide.distanceFromHotel;
      currFields.units.value = cityGuide.units;
      currFields.isActive.value = cityGuide.isActive;
      currFields.duration.value = cityGuide.duration.duration;
      currFields.tillFromDate.value = cityGuide.duration.tillFromDate;
      currFields.tillFromDate.validations =
        cityGuide.duration.duration === 'scheduled' ? ['required', 'validDate'] : [];
      currFields.tillFromTime.value = cityGuide.duration.tillFromTime;
      currFields.tillFromTime.validations =
        cityGuide.duration.duration === 'scheduled' ? ['required', 'validTime'] : [];
      currFields.validFromDate.value = cityGuide.duration.validFromDate;
      currFields.validFromDate.validations =
        cityGuide.duration.duration === 'scheduled' ? ['required', 'validDate'] : [];
      currFields.validFromTime.value = cityGuide.duration.validFromTime;
      currFields.validFromTime.validations =
        cityGuide.duration.duration === 'scheduled' ? ['required', 'validTime'] : [];
      currFields.addressLine1.value = cityGuide.location.addressLine1;
      currFields.addressLine2.value = cityGuide.location.addressLine2;
      currFields.country.value = cityGuide.location.country;
      currFields.state.value = cityGuide.location.state;
      currFields.postalCode.value = cityGuide.location.postalCode;
      currFields.city.value = cityGuide.location.city;
      currFields.latitude.value = cityGuide.location.latitude;
      currFields.longitude.value = cityGuide.location.longitude;
      currFields.area.value = cityGuide.location.area;
      currFields.timeZone.value = cityGuide.location.timeZone;
      setContactInfoList(
        cityGuide.information?.map((currInfo, ndx) => {
          return {
            index: ndx,
            value: setInfoValue(currInfo),
            type: currInfo.type,
            field: currInfo.title,
            displayTitle: currInfo.displayTitle,
          };
        }),
      );
      currFields.images.value = cityGuide.images || [];
      currFields.customAttributes.value = cityGuide.customAttributes || [];
      const { Video: mcVideo, GIF: mcGif } = decodeMediaKeyValue(cityGuide.mediaContent);
      const videoData = mcVideo || cityGuide.videos || {};
      const gifData = mcGif || cityGuide.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
      setFormData(currFields);
    }
  }, [cityGuide]);

  const validate = (tabValue, formObject, isUpdatedField) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formObject).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, isUpdatedField ? updatedFields : false);
    if (isUpdatedField) setFormData(updatedFields);
    return isValid;
  };
  const isStrictDDMMYYYY = (s) =>
    /^\d{2}-\d{2}-\d{4}$/.test(String(s || '')) && moment(s, 'DD-MM-YYYY', true)?.isValid();

  useEffect(() => {
    const isValid = validate(tabValue, formData, false);
    if (tabValue === 1) setIsTabInValid(validateTillFromDate() || validateTillFromTime());
    else setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const locationData = {
        addressLine1: formData.addressLine1.value,
        addressLine2: formData.addressLine2.value,
        country: formData.country.value,
        state: formData.state.value,
        postalCode: formData.postalCode.value,
        city: formData.city.value,
        latitude: formData.latitude.value,
        longitude: formData.longitude.value,
        timeZone: formData.timeZone.value,
        area: formData.area.value,
      };
      const duration = {
        duration: formData.duration.value,
        validFromDate: formData.validFromDate.value,
        validFromTime: formData.validFromTime.value,
        tillFromDate: formData.tillFromDate.value,
        tillFromTime: formData.tillFromTime.value,
      };
      const information = contactInfoList.map((val) => {
        return {
          type: val.type,
          email: val.type === 'EMAIL' ? val.value : '',
          phone: val.type === 'PHONE' ? val.value : '',
          URL: val.type === 'URL' || val.type === 'SOCIAL_MEDIA' ? val.value : '',
          title: val.field,
          displayTitle: val.displayTitle,
        };
      });
      const payload = {
        hotelId,
        categoryId: formData.categoryId.value,
        name: formData.name.value,
        code: formData.code.value,
        description: formData.description.value,
        distanceFromHotel: formData.distanceFromHotel.value,
        units: formData.units.value,
        isActive: formData.isActive.value,
        location: locationData,
        information: information,
        duration: duration,
      };
      payload.images = await getProcessedImages(
        rawImages,
        originalHotels.find((hotel) => hotel.id === hotelId).groupId,
        CITY_GUIDE_IMAGE_TYPE,
        hotelId,
      );
      const gifData = await processGifsForUpload({
        rawGifs,
        groupId,
        propertyType: CITY_GUIDE_IMAGE_TYPE,
        hotelId,
      });
      const mediaContent = toMediaContent({
        videoList: rawVideos,
        videoImageUrl,
        gifList: gifData,
        gifImageUrl,
      });
      payload.mediaContent = mediaContent;
      payload.customAttributes = formData.customAttributes.value;
      if (cityGuide?.id) {
        payload.id = cityGuide?.id;
        await editCityGuide(payload, language);
      } else {
        await addCityGuide(payload, language);
      }
      dispatch(fetchAllCityGuide(hotelId));
      toggleDrawer('', false, '');
      notificationManager(
        'success',
        `City guide ${cityGuide?.id ? 'updated' : 'created'} successfully`,
      );
      setLoading(false);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Error occurred while ${cityGuide ? 'updating' : 'creating'} city guide `,
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onClickNext = () => {
    if (validate(tabValue, formData, true)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      return;
    }
    if (!validate(tabValue, formData, true)) {
      return;
    }
    if (newValue > 1 && formData?.duration?.value === 'scheduled') {
      const isDurationValid =
        validate(1, formData, true) && !validateTillFromDate() && !validateTillFromTime();

      if (!isDurationValid) {
        setTabValue(1);
        return;
      }
    }
    if (newValue > 2 && !validate(2, formData, true)) {
      setTabValue(2);
      return;
    }
    setTabValue(newValue);
  };

  const handleDatePickerChange = (date, value, type) => {
    const curr = { ...formData[type], errors: { ...(formData[type]?.errors || {}) } };
    if (value == null || value === '') {
      curr.value = '';
      handleValidation(curr);
      setFormData({ [type]: curr });
      if (type === 'validFromDate' || type === 'tillFromDate') setIsValidDate(false);
      return;
    }
    if (type === 'validFromTime' || type === 'tillFromTime') {
      curr.value = value;
      handleValidation(curr);
      setFormData({ [type]: curr });
      return;
    }
    if (typeof value === 'string') curr.value = value;
    if (date && moment(date)?.isValid()) curr.value = moment(date)?.format('DD-MM-YYYY');

    handleValidation(curr);

    const raw = curr.value;
    let parsed = null;
    if (raw) {
      parsed = moment(raw, 'DD-MM-YYYY', true);
      const isPast =
        parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'));
      if (!isStrictDDMMYYYY(raw) || !parsed.isValid() || isPast) {
        curr.errors.validDate = 'Invalid date';
      } else {
        if (type === 'tillFromDate' && formData.validFromDate.value) {
          const start = moment(formData.validFromDate.value, 'DD-MM-YYYY', true);
          if (!(parsed?.isValid() && start?.isValid() && parsed?.isSameOrAfter(start))) {
            curr.errors.validDate = VALID_DATE_TIME_ERROR_MESSAGE;
          } else if (curr?.errors?.validDate) {
            delete curr?.errors?.validDate;
          }
        } else if (curr?.errors?.validDate) {
          delete curr?.errors?.validDate;
        }
        curr.value = parsed?.format('DD-MM-YYYY');
      }
    }
    setFormData({ [type]: curr });
    setIsValidDate(!!(parsed && parsed?.isValid()));
  };

  const validateTillFromDate = () => {
    if (!formData.validFromDate.value) return false;
    const startTime = moment(formData.validFromDate.value, 'DD-MM-YYYY');
    const endTime = moment(formData.tillFromDate.value, 'DD-MM-YYYY');
    return !endTime.isSameOrAfter(startTime);
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (type === 'validFromDate' || type === 'tillFromDate') {
      if (type === 'tillFromDate' && validateTillFromDate()) return VALID_DATE_TIME_ERROR_MESSAGE;
      if (formData[type].errors.validDate) return formData[type].errors.validDate;
    } else {
      if (type === 'tillFromTime' && validateTillFromTime()) return VALID_TIME_ERROR_MESSAGE;
      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const onChangeDuration = (e) => {
    const duration = { ...formData.duration };
    const validFromDate = { ...formData.validFromDate };
    const validFromTime = { ...formData.validFromTime };
    const tillFromDate = { ...formData.tillFromDate };
    const tillFromTime = { ...formData.tillFromTime };
    const isScheduled = e.target.value === 'scheduled';
    duration.value = e.target.value;
    validFromDate.value = isScheduled ? moment().format('DD-MM-YYYY') : '';
    validFromDate.validations = isScheduled ? ['required', 'validDate'] : [];
    validFromTime.value = isScheduled ? moment().format('HH:mm') : '';
    validFromTime.validations = isScheduled ? ['required', 'validTime'] : [];
    tillFromDate.value = isScheduled ? moment().format('DD-MM-YYYY') : '';
    tillFromDate.validations = isScheduled ? ['required', 'validDate'] : [];
    tillFromTime.value = isScheduled ? moment().add(1, 'hour').format('HH:mm') : '';
    tillFromTime.validations = isScheduled ? ['required', 'validTime'] : [];
    setFormData({
      duration,
      validFromDate,
      validFromTime,
      tillFromDate,
      tillFromTime,
    });
    setIsValidDate(true);
  };

  const onLocationSelect = async (locObj) => {
    let addressLine1 = '';
    let addressLine2 = '';
    let country = '';
    let state = '';
    let postalCode = '';
    let city = '';
    const latitude = locObj.geometry.location.lat();
    const longitude = locObj.geometry.location.lng();
    let timeZone = '';
    const currFormData = { ...formData };

    locObj.address_components.forEach((item) => {
      if (item.types.includes('street_number')) {
        addressLine1 = item.long_name;
        return;
      }

      if (item.types.includes('route')) {
        addressLine1 += ` ${item.long_name}`;
        return;
      }

      if (item.types.includes('neighborhood') && item.types.includes('political')) {
        addressLine2 = item.long_name;
        return;
      }

      if (item.types.includes('country') && item.types.includes('political')) {
        country = item.long_name;
        return;
      }

      if (item.types.includes('administrative_area_level_1') && item.types.includes('political')) {
        state = item.long_name;
        return;
      }

      if (item.types.includes('postal_code')) {
        postalCode = item.long_name;
        return;
      }

      if (item.types.includes('locality') && item.types.includes('political')) {
        city = item.long_name;
      }
    });

    try {
      const timeInSecs = new Date().getTime() / 1000;
      const res = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${timeInSecs}&key=AIzaSyAa_UAQQDPYFCyHvbDG4rlkxFYk1vgLFkM`,
      );

      if (res.data && res.data.status === 'OK' && res.data.timeZoneName) {
        timeZone = res.data.timeZoneName;
      }
    } catch (err) {
      console.error(err);
    }

    currFormData.addressLine1.value = addressLine1 || locObj.vicinity;
    currFormData.addressLine2.value = addressLine2;
    currFormData.country.value = country;
    currFormData.state.value = state;
    currFormData.postalCode.value = postalCode;
    currFormData.city.value = city;
    currFormData.latitude.value = latitude;
    currFormData.longitude.value = longitude;
    currFormData.timeZone.value = timeZone;
    setFormData(currFormData);
    validate(2, currFormData, true);
  };

  const onChangePostalCode = (e) => {
    if (e.value) {
      const isValid = validateAlphanumeric(e.value);
      if (!isValid) return false;
    }
    setFormData({ postalCode: e });
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...(formData.images?.value || [])];
    images.splice(index, 1);
    setFormData({ images: { ...formData.images, value: images } });
  };

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  const validateTillFromTime = () => {
    if (!formData.validFromTime.value) return false;
    const isDateValid = validateTillFromDate();
    if (isDateValid) return false;
    const startTime = moment(
      `${formData.validFromDate.value} ${formData.validFromTime.value}`,
      'DD-MM-YYYY HH:mm',
    );
    const endTime = moment(
      `${formData.tillFromDate.value} ${formData.tillFromTime.value}`,
      'DD-MM-YYYY HH:mm',
    );
    return !endTime.isAfter(startTime);
  };

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={CITY_GUIDE_ADD_ACTIVITY_TAB}
      onCancel={onCancel}
      tabValue={tabValue}
      maxtab={4}
      isTabInValid={isTabInValid}
      isUpdate={cityGuide ? true : false}
      loading={loading}
      handleTabChange={handleTabChange}
      title={`${cityGuide ? 'Edit' : 'Add'} Activity`}
      onClickNext={onClickNext}
      titleClass='col-md-3'
      tabClass='col-md-8'
      cancelClass='col-md-1 '
      hasVideoError={hasVideoError}
      isThumbnailUploading={isThumbnailUploading}
      isVideoLoading={isVideoLoading}
      isGifLoading={isGifLoading}
    >
      {tabValue === 0 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData.categoryId}
                  handleInputChange={(e) => {
                    setFormData({ categoryId: e });
                  }}
                  labelPrefix='Select'
                  options={cityGuideCategories}
                  hideNullOption={cityGuideCategories.length}
                />
              </div>
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                multiline={true}
                endAdornment={true}
                characterCount={true}
                maxLength={50}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.distanceFromHotel}
                handleInputChange={(e) => {
                  setFormData({ distanceFromHotel: e });
                }}
                type='number'
                max={9999999999}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                valueField='id'
                labelField='name'
                item={formData.units}
                handleInputChange={(e) => {
                  setFormData({ units: e });
                }}
                options={UNITS}
                hideNullOption={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-3 mb-3'>
              <div className='d-flex align-items-center'>
                <CustomCheckbox
                  item={formData.isActive}
                  handleInputChange={(e) => {
                    setFormData({ isActive: e });
                  }}
                  color='primary'
                />
                <CustomToolTip
                  title='Deactivating an activity hides it from Guest app'
                  placement='right-end'
                >
                  <InfoIcon style={{ marginLeft: 8 }} />
                </CustomToolTip>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <KeyValuePairList
                item={formData.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          </div>
        </div>
      )}
      {tabValue === 1 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Duration</h4>
          <div className='row'>
            <div className='custom-upload col-md-12'>
              <RadioGroup
                row
                aria-label={formData.duration.fieldName}
                onChange={(e) => onChangeDuration(e)}
                value={formData.duration.value}
                name={formData.duration.fieldName}
                className='document-type mb-3'
              >
                <FormControlLabel
                  value='alwaysActive'
                  control={<Radio color='primary' />}
                  label='Always Active'
                  className='me-5'
                />
                <FormControlLabel
                  value='scheduled'
                  control={<Radio color='primary' />}
                  label='Scheduled'
                />
              </RadioGroup>
            </div>
            {formData.duration.value === 'scheduled' && (
              <>
                <h5 className='tab-title'>Valid From</h5>
                <div className='row mb-2'>
                  <div className='col-md-6 mb-2'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        minDate={new Date()}
                        variant='inline'
                        margin='normal'
                        id='fromDate'
                        label='Date'
                        className='col-md-12 mb-2'
                        format='DD-MM-YYYY'
                        required={true}
                        inputValue={formData.validFromDate.value}
                        onChange={(date, value) =>
                          handleDatePickerChange(date, value, 'validFromDate')
                        }
                        error={
                          formData.validFromDate?.errors.required ||
                          formData.validFromDate?.errors.validDate
                            ? true
                            : false
                        }
                        helperText={setErrorText('validFromDate')}
                        disableMaskedInput
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className='col-md-6 mb-2'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardTimePicker
                        variant='inline'
                        margin='normal'
                        id='fromTime'
                        label='Time'
                        className='col-md-12 mb-2'
                        ampm={false}
                        format='HH:mm'
                        required={true}
                        inputValue={formData.validFromTime.value}
                        onChange={(date, value) =>
                          handleDatePickerChange(date, value, 'validFromTime')
                        }
                        error={
                          formData.validFromTime?.errors.required ||
                          formData.validFromTime?.errors.validTime
                            ? true
                            : false
                        }
                        helperText={setErrorText('validFromTime')}
                        keyboardIcon={<WatchLaterIcon />}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <h5 className='tab-title'>Valid Till</h5>
                <div className='row mb-2'>
                  <div className='col-md-6 mb-2'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        minDate={new Date()}
                        variant='inline'
                        margin='normal'
                        id='fromDate'
                        label='Date'
                        className='col-md-12 mb-2'
                        format='DD-MM-YYYY'
                        required={true}
                        inputValue={formData.tillFromDate.value}
                        onChange={(date, value) =>
                          handleDatePickerChange(date, value, 'tillFromDate')
                        }
                        error={
                          formData.tillFromDate?.errors.required ||
                          formData.tillFromDate?.errors.validDate ||
                          validateTillFromDate()
                            ? true
                            : false
                        }
                        helperText={setErrorText('tillFromDate')}
                        disableMaskedInput
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className='col-md-6 mb-2'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardTimePicker
                        variant='inline'
                        margin='normal'
                        id='fromTime'
                        label='Time'
                        className='col-md-12 mb-2'
                        ampm={false}
                        format='HH:mm'
                        required={true}
                        inputValue={formData.tillFromTime.value}
                        onChange={(date, value) =>
                          handleDatePickerChange(date, value, 'tillFromTime')
                        }
                        error={
                          formData.tillFromTime?.errors.required ||
                          formData.tillFromTime?.errors.validTime ||
                          validateTillFromTime()
                            ? true
                            : false
                        }
                        helperText={setErrorText('tillFromTime')}
                        keyboardIcon={<WatchLaterIcon />}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {tabValue === 2 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Location</h4>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <LocationInput onLocationSelect={onLocationSelect} />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.addressLine1}
                handleInputChange={(e) => {
                  setFormData({ addressLine1: e });
                }}
                maxLength='150'
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.addressLine2}
                handleInputChange={(e) => {
                  setFormData({ addressLine2: e });
                }}
                maxLength='150'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                item={formData.country}
                handleInputChange={(e) => {
                  setFormData({ country: e });
                }}
                labelField='name'
                valueField='name'
                labelPrefix='Select'
                options={Countries}
                hideNullOption={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.state}
                handleInputChange={(e) => {
                  setFormData({ state: e });
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.postalCode}
                handleInputChange={(e) => onChangePostalCode(e)}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.city}
                handleInputChange={(e) => {
                  setFormData({ city: e });
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.latitude}
                handleInputChange={(e) => {
                  setFormData({ latitude: e });
                }}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.longitude}
                handleInputChange={(e) => {
                  setFormData({ longitude: e });
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.area}
                handleInputChange={(e) => {
                  setFormData({ area: e });
                }}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.timeZone}
                handleInputChange={(e) => {
                  setFormData({ timeZone: e });
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`col-md-12 ${
                !(formData.latitude && formData.longitude) ? 'disabled-container' : ''
              }`}
            >
              <LocationMap lat={formData.latitude.value} lng={formData.longitude.value} />
            </div>
          </div>
        </div>
      )}
      {tabValue === 3 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Information</h4>
          <ContactInformation
            informationTypes={CITYGUIDE_INFO_TYPES}
            setContactInfoList={setContactInfoList}
            contactInfoList={contactInfoList}
            infoFieldKey='field'
            infoValueKey='value'
          />
        </div>
      )}
      {tabValue === 4 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Media</h4>
          <ImageUpload
            uploadedImages={formData.images.value}
            imgList={rawImages}
            onImageListUpdated={onImageListUpdated}
            onUploadedImageRemoval={onUploadedImageRemoval}
            onImagesLoading={(status) => {
              setLoading(status);
            }}
            videoImageUrl={videoImageUrl}
            onVideoImageUrlChange={setVideoImageUrl}
            gifImageUrl={gifImageUrl}
            onGifImageUrlChange={setGifImageUrl}
            videoList={rawVideos}
            gifList={rawGifs}
            onVideoListUpdated={setRawVideos}
            onGifListUpdated={setRawGifs}
            hotelId={hotelId}
            groupId={groupId}
            propertyType={CITY_GUIDE_IMAGE_TYPE}
            onVideoError={setHasVideoError}
            onThumbnailUploading={setIsThumbnailUploading}
            onVideoLoading={setIsVideoLoading}
            onGifLoading={setIsGifLoading}
          />
        </div>
      )}
    </CustomFormView>
  );
};

export default CityGuideCreate;
